import { AbstractModel } from './AbstractModel'

export class Discount extends AbstractModel {
    static readonly idKey = 'customer_rally_round_discount_id'

    id: number|null = null;
    rallyId: number|null = 0;
    rallyRoundId: number|null = 0;
    customerId = 0;
    percent: number|null = null;
    name: string|null = null;
    email: string|null = null;
    redeemed: boolean|null = null;
    validFrom: string|null = null;
    validTil: string|null = null;
    endlessRedeemable: boolean|null = null;
    info = '';
}
